import React, { Component } from 'react';
import '../App.css';
import MyFlowsListItemComponent from '../components/MyFlowsListItemComponent'
import { withRouter } from 'react-router-dom'
import { getJson } from '../helpers/RequestsHelper'
import MyFlowsStatistics from '../components/MyFlowsStatistics';
import { withTranslation } from 'react-i18next';
import Joyride from 'react-joyride';

class MyFlowsPage extends Component {

    onboarding = {
        "template": [
            {
                target: '.custom-switch',
                disableBeacon: true,
                content: 'Use this switch to turn on/off the execution of the workflow',
            }
        ]
    }

    state = {
        loading: true,
        items: []
    }

    constructor() {
        super()
        this.onUpdate = this.onUpdate.bind(this)
    }

    componentDidMount() {
        const { t } = this.props;
        //TODONOW: helmet document.title = t("titleappname") + t("title_myworkflows")
        this.fillFlows(this.props.provider);
    }

    async fillFlows() {
        const json = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows");
        const sharedwithme = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/sharedwithme");
        const statistics = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/all/statistics");

        let total = { countStart: 0, count: 0, from_completed: 0, to_completed: 0, first_execution: undefined, last_execution: undefined }
        for (let i = 0; i < statistics.length; i++) {
            const flow = statistics[i];
            total.countStart += flow.countStart
            total.count += flow.count
            total.from_completed += flow.from_completed
            total.to_completed += flow.to_completed
            if (flow.first_execution < total.first_execution || total.first_execution === undefined) {
                total.first_execution = flow.first_execution
            }
            if (flow.last_execution > total.last_execution) {
                total.last_execution = flow.last_execution
            }
        }
        
        // var searchParams = new URLSearchParams(window.location.search)
        // const onboarding = searchParams.get("onboarding");
        const onboarding = this.props.onboarding

        this.setState(({ items: json, sharedwithme, loading: false, statistics, total, onboarding }));
    }

    onUpdate() {
        this.fillFlows(this.props.provider);
    }

    render() {
        if (this.state.loading) {
            return <div><h3>My Workflows</h3><div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div></div>
        }

        let drafts = []
        let workflows = []
        let sharedwithme = []
        this.state.items.forEach(workflow => {
            const stats = this.state.statistics.find(a => a._id == workflow._id)
            if (workflow.draft) {
                drafts.push(
                    <MyFlowsListItemComponent key={workflow._id + (stats ? stats.count : "")} data={workflow} onUpdate={this.onUpdate} statistics={stats} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            } else {
                workflows.push(
                    <MyFlowsListItemComponent key={workflow._id + (stats ? stats.count : "")} data={workflow} onUpdate={this.onUpdate} statistics={stats} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            }
        })
        if (this.state.sharedwithme) {
            this.state.sharedwithme.forEach(workflow => {
                const stats = this.state.statistics.find(a => a._id == workflow._id)

                sharedwithme.push(
                    <MyFlowsListItemComponent key={workflow._id + (stats ? stats.count : "")} data={workflow} onUpdate={this.onUpdate} statistics={stats} isLegacy={this.props.isLegacy} windowWidth={this.props.windowWidth} />
                )
            })
        }
        return (
            <div className="list-group">
                <h3>My Workflows</h3>
                <MyFlowsStatistics key={"total" + this.state.total.count} statistics={this.state.total} />
                {workflows.length > 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">Workflows</p>
                            {workflows}
                        </div>
                    </>
                    : ""}
                {drafts.length > 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">Drafts</p>
                            {drafts}
                        </div>
                    </>
                    : ""}
                {sharedwithme.length > 0 ?
                    <>
                        <br />
                        <div className="apps-group">
                            <p className="apps-group-title">Shared with me</p>
                            {sharedwithme}
                        </div>
                    </>
                    : ""}
                    
                {this.state.onboarding ? <Joyride steps={this.onboarding[this.state.onboarding]} callback={async () => await this.props.onboardingUpdate(false)}/> : <></>}
            </div>)
    }
}

export default withRouter(withTranslation()(MyFlowsPage), MyFlowsPage);